import {esNombreInvalido,requiereCorreccionFecha} from './shared/monitorCorrectionRules';
import React, { useState, useCallback, useMemo, useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import { Box, Typography, CircularProgress, Tooltip } from '@mui/material';
import { authService } from '../services/api';
import api from '../services/api';
import { HeaderIOS, IOS } from './shared/MenuLayout';
import EnvioMasivoPanel from './EnvioMasivoPanel';
import MonitorCleanup, {maintenanceButtonSx,maintenanceRowSx} from './shared/MonitorCleanup';
import MonitorFleet from './shared/MonitorFleet';
import {PharmacyTabs,PharmacySelect,PharmacyMetric} from './shared/PharmacyUI';
import {Alert,TablePagination,Button,Checkbox} from '@mui/material';
import './shared/MonitorEnvios.css';
import MonitorChart from './shared/MonitorChart';
import { useNavigate, useSearchParams } from 'react-router-dom';





const CORRECTION_DAYS={factura:3,boleta:5,nota:5};
const MODULOS = ['Ventas','Archivos','Configuración','Stock','ICI DETALLE','ICI','Detalle IME','IME','Detalle Venta','Detalle ICI'];


const fmtFecha = (s) => {
  if(!s) return '—';
  const str=typeof s==='string'&&s.length===10?s+'T00:00:00':s;
  const d=new Date(str); return isNaN(d)?s:d.toLocaleDateString('es-PE',{day:'2-digit',month:'2-digit',year:'numeric'});
};
const fmtHora = (s) => {
  if(!s) return '';
  const d=new Date(s); return isNaN(d)?'':d.toLocaleTimeString('es-PE',{hour:'2-digit',minute:'2-digit'});
};
const hoy = () => {
  const d=new Date(); const y=d.getFullYear();
  const m=String(d.getMonth()+1).padStart(2,'0'); const dia=String(d.getDate()).padStart(2,'0');
  return `${y}-${m}-${dia}`;
};

const ESTADO_CFG = {
  'AL DIA':    {bg:'#EDFAF2',border:'#B7EFD0',txt:'#1A6B3C',dot:IOS?.green||'#34C759',label:'AL DÍA'},
  'EN RIESGO': {bg:'#FFF8E6',border:'#FFE9A0',txt:'#8B6914',dot:'#FF9500',label:'EN RIESGO'},
  'ATRASADO':  {bg:'#FFF0EF',border:'#FFD4D1',txt:'#C0392B',dot:'#FF3B30',label:'ATRASADO'},
  'SIN ENVIO': {bg:'#F2F2F7',border:'#D1D1D6',txt:'#636366',dot:'#8E8E93',label:'SIN ENVÍO'},
};

// ── Componentes base ──────────────────────────────────────────────────────────
const Lbl = ({children}) => (
  <Typography sx={{fontSize:'0.72rem',fontWeight:700,color:IOS.label2,letterSpacing:'0.07em',textTransform:'uppercase',mb:0.5}}>{children}</Typography>
);

const PillEstado = ({estado,sm}) => {
  const cfg=ESTADO_CFG[estado]||ESTADO_CFG['SIN ENVIO'];
  return (
    <Box sx={{display:'inline-flex',alignItems:'center',gap:0.5,px:sm?0.8:1,py:sm?0.15:0.25,
      borderRadius:'20px',bgcolor:cfg.bg,border:`1px solid ${cfg.border}`,whiteSpace:'nowrap'}}>
      <Box sx={{width:sm?4:5,height:sm?4:5,borderRadius:'50%',bgcolor:cfg.dot,flexShrink:0}}/>
      <Typography sx={{fontSize:sm?'0.58rem':'0.62rem',fontWeight:700,color:cfg.txt}}>{cfg.label}</Typography>
    </Box>
  );
};

// Dropdown custom sin flash negro
const Sel = (props) => <PharmacySelect {...props}/>;

const DIAS_SEMANA = ['D','L','M','M','J','V','S'];
const MESES_LARGO = ['Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'];
const toYMD = (d) => `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`;
const parseYMD = (s) => { if(!s) return new Date(); const [y,m,d] = s.split('-').map(Number); return new Date(y, m-1, d); };

const DatePickerIOS = ({ value, onChange, w='100%', minDate, maxDate }) => {
  const [open, setOpen] = useState(false);
  const [rect, setRect] = useState(null);
  const ref = useRef(null);
  const popupRef = useRef(null);
  const selDate = value ? parseYMD(value) : null;
  const [viewMonth, setViewMonth] = useState(selDate ? selDate.getMonth() : new Date().getMonth());
  const [viewYear, setViewYear] = useState(selDate ? selDate.getFullYear() : new Date().getFullYear());

  useEffect(() => {
    const h = e => {
      const dentroTrigger = ref.current && ref.current.contains(e.target);
      const dentroPopup = popupRef.current && popupRef.current.contains(e.target);
      if (!dentroTrigger && !dentroPopup) setOpen(false);
    };
    document.addEventListener('mousedown', h);
    return () => document.removeEventListener('mousedown', h);
  }, []);

  const handleOpen = () => {
    if (ref.current) setRect(ref.current.getBoundingClientRect());
    if (selDate) { setViewMonth(selDate.getMonth()); setViewYear(selDate.getFullYear()); }
    setOpen(v=>!v);
  };

  const cambiarMes = (delta) => {
    let m = viewMonth + delta, y = viewYear;
    if (m < 0) { m = 11; y--; } else if (m > 11) { m = 0; y++; }
    setViewMonth(m); setViewYear(y);
  };

  const minD = minDate ? parseYMD(minDate) : null;
  const maxD = maxDate ? parseYMD(maxDate) : null;
  const fueraDeRango = (dia) => {
    const d = new Date(viewYear, viewMonth, dia);
    if (minD && d < minD) return true;
    if (maxD && d > maxD) return true;
    return false;
  };
  const elegirDia = (dia) => { if(fueraDeRango(dia)) return; onChange(toYMD(new Date(viewYear, viewMonth, dia))); setOpen(false); };

  const hoyD = new Date();
  const primerDiaSemana = new Date(viewYear, viewMonth, 1).getDay();
  const totalDias = new Date(viewYear, viewMonth+1, 0).getDate();
  const celdas = [...Array(primerDiaSemana).fill(null), ...Array.from({length:totalDias},(_,i)=>i+1)];
  const labelFecha = selDate ? `${String(selDate.getDate()).padStart(2,'0')}/${String(selDate.getMonth()+1).padStart(2,'0')}/${selDate.getFullYear()}` : '';

  return (
    <Box ref={ref} sx={{ position:'relative', width:w }}>
      <Box onClick={handleOpen}
        sx={{ height:34, px:1.2, display:'flex', alignItems:'center', gap:0.8,
          border:`1px solid ${open?IOS.blue:IOS.separator}`, borderRadius:'8px',
          bgcolor:IOS.surface, cursor:'pointer', userSelect:'none',
          boxShadow:open?`0 0 0 3px ${IOS.blue}18`:'none', transition:'all 0.15s', boxSizing:'border-box' }}>
        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke={IOS.label2} strokeWidth="2" strokeLinecap="round">
          <rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/>
        </svg>
        <Typography sx={{ fontSize:'0.8rem', color:IOS.label, flex:1, whiteSpace:'nowrap' }}>{labelFecha}</Typography>
      </Box>

      {open && rect && ReactDOM.createPortal(
        <Box ref={popupRef} sx={{ position:'fixed', top:rect.bottom+4, left:rect.left, zIndex:99999,
          bgcolor:IOS.surface, border:`1px solid ${IOS.separator}`, borderRadius:'14px',
          boxShadow:'0 8px 24px rgba(0,0,0,0.16)', width:260, p:1.5 }}>

          <Box sx={{ display:'flex', alignItems:'center', justifyContent:'space-between', mb:1 }}>
            <Box component="button" onClick={()=>cambiarMes(-1)}
              sx={{ width:26, height:26, borderRadius:'8px', border:'none', bgcolor:IOS.bg, cursor:'pointer',
                display:'flex', alignItems:'center', justifyContent:'center' }}>
              <svg width="9" height="9" viewBox="0 0 24 24" fill="none" stroke={IOS.label} strokeWidth="3" strokeLinecap="round"><polyline points="15 18 9 12 15 6"/></svg>
            </Box>
            <Typography sx={{ fontSize:'0.82rem', fontWeight:700, color:IOS.label }}>{MESES_LARGO[viewMonth]} {viewYear}</Typography>
            <Box component="button" onClick={()=>cambiarMes(1)}
              sx={{ width:26, height:26, borderRadius:'8px', border:'none', bgcolor:IOS.bg, cursor:'pointer',
                display:'flex', alignItems:'center', justifyContent:'center' }}>
              <svg width="9" height="9" viewBox="0 0 24 24" fill="none" stroke={IOS.label} strokeWidth="3" strokeLinecap="round"><polyline points="9 18 15 12 9 6"/></svg>
            </Box>
          </Box>

          <Box sx={{ display:'grid', gridTemplateColumns:'repeat(7,1fr)', mb:0.5 }}>
            {DIAS_SEMANA.map((d,i)=>(<Typography key={i} sx={{ fontSize:'0.72rem', fontWeight:700, color:IOS.label2, textAlign:'center' }}>{d}</Typography>))}
          </Box>

          <Box sx={{ display:'grid', gridTemplateColumns:'repeat(7,1fr)', gap:'2px' }}>
            {celdas.map((dia,i)=>{
              if (dia===null) return <Box key={i} />;
              const esHoy = dia===hoyD.getDate() && viewMonth===hoyD.getMonth() && viewYear===hoyD.getFullYear();
              const esSel = selDate && dia===selDate.getDate() && viewMonth===selDate.getMonth() && viewYear===selDate.getFullYear();
              const disabled = fueraDeRango(dia);
              return (
                <Box key={i} onClick={()=>elegirDia(dia)}
                  sx={{ height:30, display:'flex', alignItems:'center', justifyContent:'center', borderRadius:'8px',
                    cursor:disabled?'not-allowed':'pointer', opacity:disabled?0.28:1,
                    bgcolor:esSel?IOS.blue:'transparent',
                    border:esHoy&&!esSel?`1.5px solid ${IOS.blue}`:'none' }}>
                  <Typography sx={{ fontSize:'0.78rem', fontWeight:esSel?700:500, color:esSel?'white':IOS.label }}>{dia}</Typography>
                </Box>
              );
            })}
          </Box>
        </Box>, document.body
      )}
    </Box>
  );
};

const TH = ({children,right,center,w}) => (
  <th style={{padding:'9px 8px',width:w||'auto',textAlign:right?'right':center?'center':'left',
    fontSize:'0.72rem',fontWeight:700,color:IOS.label2,letterSpacing:'0.06em',textTransform:'uppercase',
    backgroundColor:IOS.surface,borderBottom:`1px solid ${IOS.separator}`,whiteSpace:'nowrap',
    position:'sticky',top:0,zIndex:1}}>{children}</th>
);

const KpiCard = ({label,value,sub,color,icon,pct}) => (
  <PharmacyMetric label={label} value={value} color={color} icon={icon}
    sub={sub ?? (pct!==undefined ? pct.toFixed(1)+'% de sincronizaciones correctas' : undefined)}
    progress={pct}/>
);

const BtnRefresh = ({onClick,loading}) => (
  <Box component="button" onClick={onClick} disabled={loading}
    sx={{width:34,height:34,borderRadius:'50%',border:'none',bgcolor:IOS.blue,cursor:loading?'default':'pointer',
      display:'flex',alignItems:'center',justifyContent:'center',transition:'all 0.15s',
      opacity:loading?0.6:1,'&:hover':{filter:'brightness(0.9)'}}}>
    {loading
      ?<CircularProgress size={14} sx={{color:'white'}}/>
      :<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.2" strokeLinecap="round"><path d="M23 4v6h-6"/><path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"/></svg>
    }
  </Box>
);

// ── Tab Resumen Cards móvil ───────────────────────────────────────────────────
const IpressCard = ({row}) => {
  const dias=row.DIAS_SIN_ENVIO;
  const diasColor=dias===null?IOS.label2:dias<=2?IOS.green:dias===3?IOS.orange:IOS.red;
  return (
    <Box sx={{p:2,borderBottom:`1px solid ${IOS.separator}`}}>
      <Box sx={{display:'flex',justifyContent:'space-between',alignItems:'flex-start',mb:1}}>
        <Typography sx={{fontWeight:700,fontSize:'0.82rem',color:IOS.label,flex:1,mr:1,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{row.IPRESS}</Typography>
        <PillEstado estado={row.ESTADO} sm />
      </Box>
      <Box sx={{display:'flex',gap:2,alignItems:'center'}}>
        <Typography sx={{fontSize:'0.7rem',color:IOS.label2}}>
          {row.ULTIMO_ENVIO?<>{fmtFecha(row.ULTIMO_ENVIO)} <span style={{color:IOS.label2}}>{fmtHora(row.ULTIMO_ENVIO)}</span></>:'Sin envíos'}
        </Typography>
        {dias!==null&&<Typography sx={{fontWeight:800,fontSize:'0.82rem',color:diasColor}}>{dias}d</Typography>}
      </Box>
    </Box>
  );
};

const ErrorCard = ({row,onVerDetalle}) => (
  <Box onClick={()=>onVerDetalle(row)} sx={{p:2,borderBottom:`1px solid ${IOS.separator}`,cursor:'pointer'}}>
    <Box sx={{display:'flex',justifyContent:'space-between',alignItems:'flex-start',gap:1,mb:0.8}}>
      <Typography sx={{fontWeight:700,fontSize:'0.8rem',color:IOS.label,flex:1,minWidth:0,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{row.IPRESS}</Typography>
      <Box sx={{display:'inline-flex',px:0.7,py:0.2,borderRadius:'6px',bgcolor:`${IOS.purple}12`,border:`1px solid ${IOS.purple}25`,flexShrink:0}}>
        <Typography sx={{fontSize:'0.72rem',fontWeight:700,color:IOS.purple}}>{row.MODULO}</Typography>
      </Box>
    </Box>
    <Typography sx={{fontSize:'0.74rem',color:IOS.label,mb:0.4}}>{row.EVENTO}</Typography>
    <Typography sx={{fontSize:'0.7rem',color:IOS.red,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap',mb:0.6}}>{row.DETALLE}</Typography>
    <Box sx={{display:'flex',justifyContent:'space-between',alignItems:'center'}}>
      <Typography sx={{fontSize:'0.65rem',color:IOS.label2}}>{fmtFecha(row.FECHA)} {fmtHora(row.FECHA)}</Typography>
      <Typography sx={{fontSize:'0.65rem',color:IOS.blue,fontWeight:700}}>Ver detalle →</Typography>
    </Box>
  </Box>
);

const RechazoCard = ({row,i}) => (
  <Box sx={{p:2,borderBottom:`1px solid ${IOS.separator}`}}>
    <Box sx={{display:'flex',justifyContent:'space-between',alignItems:'flex-start',mb:0.8}}>
      <Box sx={{flex:1,minWidth:0,mr:1}}>
        <Typography sx={{fontWeight:700,fontSize:'0.8rem',color:IOS.label,whiteSpace:'pre-wrap',overflowWrap:'anywhere'}}>{row.Cliente}</Typography>
        <Typography sx={{fontSize:'0.68rem',color:IOS.label2,fontFamily:'monospace'}}>{row.Comprobante} · {row.Fecha}</Typography>
      </Box>
      <Typography sx={{fontWeight:800,fontSize:'0.88rem',color:IOS.label,flexShrink:0}}>S/{parseFloat(row.Total||0).toFixed(2)}</Typography>
    </Box>
    <Box sx={{display:'flex',gap:0.8,flexWrap:'wrap',mb:0.8}}>
      <Box sx={{display:'inline-flex',px:0.8,py:0.2,borderRadius:'20px',
        bgcolor:row.Estado==='RECHAZADO'?'#FFF0EF':'#FFF8E6',
        border:`1px solid ${row.Estado==='RECHAZADO'?'#FFD4D1':'#FFE9A0'}`}}>
        <Box sx={{width:4,height:4,borderRadius:'50%',bgcolor:row.Estado==='RECHAZADO'?IOS.red:IOS.orange,mr:0.5,mt:0.4,flexShrink:0}}/>
        <Typography sx={{fontSize:'0.72rem',fontWeight:700,color:row.Estado==='RECHAZADO'?'#C0392B':'#8B6914'}}>{row.Estado}</Typography>
      </Box>
      <Box sx={{display:'inline-flex',px:0.8,py:0.2,borderRadius:'20px',bgcolor:`${IOS.purple}10`,border:`1px solid ${IOS.purple}25`}}>
        <Typography sx={{fontSize:'0.72rem',fontWeight:600,color:IOS.purple}}>{row.TipoCPE}</Typography>
      </Box>
    </Box>
    {row.LOG_MENSAJE&&<Typography sx={{fontSize:'0.8rem',lineHeight:1.6,color:row.Estado==='RECHAZADO'?IOS.red:IOS.label2,whiteSpace:'pre-wrap',overflowWrap:'anywhere'}}>{row.LOG_MENSAJE}</Typography>}
    <Typography sx={{fontSize:'0.65rem',color:IOS.label2,mt:0.3}}>{row.NOMBRE}</Typography>
  </Box>
);

// ══════════════════════════════════════════════════════════════════════════════
const MonitorEnvios = ({modulo='economia'}) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams(); // ← agregá esta línea
  const desde = searchParams.get('desde'); // ← y esta
  const user = authService.getCurrentUser();
  const ueId = user?.ueIdEstablecimiento||user?.UeIdEstablecimiento||0;

  const [docPage,setDocPage]=useState(0);
  const [tab,setTab]               = useState('ipress');
  const [fechaInicio,setFechaInicio] = useState(hoy());
  const [fechaFin,setFechaFin]       = useState(hoy());
  const [moduloSel,setModuloSel]     = useState('Ventas');
  const [busqueda,setBusqueda]       = useState('');
  const [busquedaRec,setBusquedaRec] = useState('');

  const [syncPage,setSyncPage]=useState(0);
  const days=CORRECTION_DAYS;
  const [fleet,setFleet]=useState([]),[fleetLoading,setFleetLoading]=useState(false),[fleetError,setFleetError]=useState(''),[canSend,setCanSend]=useState(false),[loadError,setLoadError]=useState('');
  const [accessError,setAccessError]=useState('');
  useEffect(()=>{let live=true;api.get('/economia/MonitorEnvios/permisos').then(r=>{if(live)setCanSend(r.data.canSend===true);}).catch(()=>{if(live){setCanSend(false);setAccessError('No se pudieron verificar tus permisos. Recarga la página para reintentar.');}});return()=>{live=false;};},[]);
  const loadFleet=useCallback(async()=>{setFleetLoading(true);setFleetError('');try{const r=await api.get('/economia/MonitorEnvios/versiones');setFleet(r.data.data||[]);}catch(e){setFleetError(e.response?.data?.message||'No se pudieron consultar las versiones.');}finally{setFleetLoading(false);}},[]);
  useEffect(()=>{loadFleet();},[loadFleet]);
  const [resumen,setResumen]     = useState(null);
  const [ipress,setIpress]       = useState([]);
  const [ipressEnv,setIpressEnv] = useState([]);
  const [modulos,setModulos]     = useState([]);
  const [errores,setErrores]     = useState([]);
  const [tendencia,setTendencia] = useState([]);
  const [rechazos,setRechazos]   = useState([]);

  const [cargando,setCargando]       = useState(false);
  const [cargandoRec,setCargandoRec] = useState(false);
  const [modalFecha,setModalFecha]   = useState(null); // fila seleccionada (corrección individual)
  const [nuevaFecha,setNuevaFecha]   = useState('');
  const [corrigiendo,setCorrigiendo] = useState(false);
  const [seleccionados,setSeleccionados] = useState(new Set());
  const [modalLote,setModalLote]     = useState(false);
  const [modalNombre,setModalNombre] = useState(null);
  const [corrigiendoNombre,setCorrigiendoNombre] = useState(false);
  const [resultadoNombre,setResultadoNombre]     = useState(null);
  const [nombreManual,setNombreManual]           = useState('CLIENTE EVENTUAL');
  const [historialFallo,setHistorialFallo]       = useState(false);
  const [reniecFallo,setReniecFallo]             = useState(false);
  const [envioRefreshKey,setEnvioRefreshKey]     = useState(0);
  const [envioEnCurso,setEnvioEnCurso]           = useState(false);
  const [nuevaFechaLote,setNuevaFechaLote] = useState('');
  const [ultimaAct,setUltimaAct]     = useState(null);
  const [ultimaActRec,setUltimaActRec] = useState(null);
  const [estadoFiltro,setEstadoFiltro] = useState(null);
  const [errorDetalle,setErrorDetalle] = useState(null);
  const [ipressFiltroErr,setIpressFiltroErr] = useState(null);

  const handleLogout = () => { authService.logout(); navigate('/login'); };

  const cargarTodo = useCallback(async () => {
    setCargando(true);setLoadError('');
    try {
      const params={fechaInicio,fechaFin,ueId};
      const [r1,r2,r3,r4,r5,r6] = await Promise.all([
        api.get('/economia/MonitorEnvios/resumen-dia',     {params}),
        api.get('/economia/MonitorEnvios/ipress',          {params}),
        api.get('/economia/MonitorEnvios/ipress-envio',    {params:{modulo:moduloSel,ueId}}),
        api.get('/economia/MonitorEnvios/modulos',         {params}),
        api.get('/economia/MonitorEnvios/errores-detalle', {params}),
        api.get('/economia/MonitorEnvios/tendencia',       {params:{dias:10,ueId}}),
      ]);
      if(r1.data.success) setResumen(r1.data.data[0]||null);
      if(r2.data.success) setIpress(r2.data.data);
      if(r3.data.success) setIpressEnv(r3.data.data);
      if(r4.data.success) setModulos(r4.data.data);
      if(r5.data.success) setErrores(r5.data.data);
      if(r6.data.success) setTendencia(r6.data.data);
      setUltimaAct(new Date());
    } catch(e){setLoadError(e.response?.data?.message||'No se pudo cargar la sincronización. Reintenta.');} finally{setCargando(false);}
  },[fechaInicio,fechaFin,ueId,moduloSel]);

  const toggleSeleccion = (fvId) => {
    if(!canSend)return;
    setSeleccionados(prev => {
      const next = new Set(prev);
      if(next.has(fvId)) next.delete(fvId); else next.add(fvId);
      return next;
    });
  };

  const toggleSeleccionarTodos = (filasConId) => {
    if(!canSend)return;
    setSeleccionados(prev => {
      const todosMarcados = filasConId.every(id => prev.has(id));
      if(todosMarcados) return new Set();
      return new Set(filasConId);
    });
  };

  const corregirFechaLote = async () => {
    if(!canSend)return;
    if(seleccionados.size===0||!nuevaFechaLote) return;
    setCorrigiendo(true);
    try {
      const r = await api.post('/economia/EnvioMasivoSunat/corregir-fecha-lote', {
        fvIds: Array.from(seleccionados),
        nuevaFecha: nuevaFechaLote
      });
      if(r.data.success){
        setModalLote(false); setNuevaFechaLote(''); setSeleccionados(new Set());
        cargarRechazos(); setEnvioRefreshKey(k=>k+1);
      } else alert(r.data.message);
    } catch(e){ alert(e?.response?.data?.message || 'Error al corregir fechas'); }
    finally { setCorrigiendo(false); }
  };

  const corregirDesdeHistorial = async () => {
    if(!canSend)return;
    if(!modalNombre) return;
    setCorrigiendoNombre(true); setResultadoNombre(null);
    try {
      const r = await api.post('/sismed/clientes/corregir-desde-historial', null, { params:{ dni: modalNombre.DNI } });
      if (r.data.filasActualizadas > 0) {
        setResultadoNombre({ ok:true, msg:'Nombre corregido desde el historial de compras.' });
        cargarRechazos(); setEnvioRefreshKey(k=>k+1);
      } else {
        setResultadoNombre({ ok:false, msg:'No hay ningún otro registro con nombre válido para este DNI — prueba con RENIEC.' });
        setHistorialFallo(true);
      }
    } catch(e){ setResultadoNombre({ ok:false, msg:e?.response?.data?.message || 'Error al corregir' }); }
    finally { setCorrigiendoNombre(false); }
  };

  const corregirConReniec = async () => {
    if(!canSend)return;
    if(!modalNombre) return;
    setCorrigiendoNombre(true); setResultadoNombre(null);
    try {
      const r = await api.post('/sismed/clientes/completar-reniec-uno', null, { params:{ dni: modalNombre.DNI } });
      if (r.data.success) {
        setResultadoNombre({ ok:true, msg:`Nombre obtenido de RENIEC: ${r.data.nombre}` });
        cargarRechazos(); setEnvioRefreshKey(k=>k+1);
      } else {
        setResultadoNombre({ ok:false, msg:r.data.message || 'RENIEC no devolvió datos para este DNI' });
        setReniecFallo(true);
      }
    } catch(e){ setResultadoNombre({ ok:false, msg:e?.response?.data?.message || 'Error al consultar RENIEC' }); }
    finally { setCorrigiendoNombre(false); }
  };

    const corregirManual = async () => {
    if(!canSend)return;
    if(!modalNombre || !nombreManual.trim()) return;
    setCorrigiendoNombre(true); setResultadoNombre(null);
    try {
      const r = await api.post('/sismed/clientes/corregir-manual', null, { params:{ dni: modalNombre.DNI, nombre: nombreManual.trim() } });
      if (r.data.success) {
        setResultadoNombre({ ok:true, msg:`Nombre asignado manualmente: ${nombreManual.trim().toUpperCase()}` });
        cargarRechazos(); setEnvioRefreshKey(k=>k+1);
      } else {
        setResultadoNombre({ ok:false, msg:r.data.message || 'No se pudo guardar el nombre' });
      }
    } catch(e){ setResultadoNombre({ ok:false, msg:e?.response?.data?.message || 'Error al guardar' }); }
    finally { setCorrigiendoNombre(false); }
  };

  const corregirFecha = async () => {
    if(!canSend)return;
    if(!modalFecha||!nuevaFecha) return;
    setCorrigiendo(true);
    try {
      const r = await api.post('/economia/EnvioMasivoSunat/corregir-fecha', {
        fvIdFacturacion: modalFecha.FV_ID_FACTURACION,
        nuevaFecha
      });
      if(r.data.success){
        setModalFecha(null); setNuevaFecha('');
        cargarRechazos(); setEnvioRefreshKey(k=>k+1);
      } else alert(r.data.message);
    } catch(e){ alert(e?.response?.data?.message || 'Error al corregir fecha'); }
    finally { setCorrigiendo(false); }
  };

  const cargarRechazos = useCallback(async () => {
    setCargandoRec(true);setLoadError('');
    try {
      const r=await api.get('/economia/MonitorEnvios/envio-pendientes',{params:{ueId}});
      if(r.data.success) setRechazos(r.data.data);
      setUltimaActRec(new Date());
    } catch(e){setLoadError(e.response?.data?.message||'No se pudo consultar el estado de los comprobantes. Reintenta.');} finally{setCargandoRec(false);}
  },[ueId]);

  const cargarIpressEnvio = useCallback(async () => {
    try {
      const r=await api.get('/economia/MonitorEnvios/ipress-envio',{params:{modulo:moduloSel,ueId}});
      if(r.data.success) setIpressEnv(r.data.data);
    } catch(e){console.error(e);}
  },[moduloSel,ueId]);

  useEffect(()=>{cargarTodo();},[cargarTodo]);
  useEffect(()=>{setEstadoFiltro(null);setIpressFiltroErr(null);},[fechaInicio,fechaFin]);
  useEffect(()=>{if(tab==='rechazos')cargarRechazos();},[tab,cargarRechazos]);
  useEffect(()=>{cargarIpressEnvio();},[cargarIpressEnvio]);

  const totalEventos = resumen?.EVENTOS??0;
  const totalOk      = resumen?.OK??0;
  const totalErr     = resumen?.ERRORES??0;
  const tasaExito    = totalEventos>0?(totalOk/totalEventos)*100:0;
  const cntAlDia     = ipressEnv.filter(x=>x.ESTADO==='AL DIA').length;
  const cntRiesgo    = ipressEnv.filter(x=>x.ESTADO==='EN RIESGO').length;
  const cntAtrasado  = ipressEnv.filter(x=>x.ESTADO==='ATRASADO').length;
  const cntSinEnv    = ipressEnv.filter(x=>x.ESTADO==='SIN ENVIO').length;
  const totalRechazos  = rechazos.length;
  const ipressConRec   = [...new Set(rechazos.map(x=>x.NOMBRE))].length;
  const totalPendiente = rechazos.reduce((a,x)=>a+(parseFloat(x.Total)||0),0);
  const tiposCPE       = [...new Set(rechazos.map(x=>x.TipoCPE))];

  const erroresFiltrados = useMemo(()=>
    ipressFiltroErr ? errores.filter(x=>x.IPRESS===ipressFiltroErr) : errores
  ,[errores,ipressFiltroErr]);

  const ipressEnvFiltrada = useMemo(()=>{
    let f = ipressEnv;
    if(busqueda) f = f.filter(x=>x.IPRESS?.toLowerCase().includes(busqueda.toLowerCase()));
    if(estadoFiltro) f = f.filter(x=>x.ESTADO===estadoFiltro);
    return f;
  },[ipressEnv,busqueda,estadoFiltro]);

  useEffect(()=>setSyncPage(0),[busqueda,estadoFiltro,moduloSel]);
  const syncSafePage=Math.min(syncPage,Math.max(0,Math.ceil(ipressEnvFiltrada.length/10)-1));
  const syncVisible=ipressEnvFiltrada.slice(syncSafePage*10,(syncSafePage+1)*10);
  const hoyYMD = toYMD(new Date());
  const minFechaCorreccion = (() => {
    const d = new Date(); const selectedRows=modalFecha?[modalFecha]:rechazos.filter(r=>seleccionados.has(r.FV_ID_FACTURACION));
    const limits=selectedRows.map(r=>/FACTURA|^01$/i.test(r.TipoCPE||'')?days?.factura:/BOLETA|^03$/i.test(r.TipoCPE||'')?days?.boleta:days?.nota);
    d.setDate(d.getDate() - Math.min(...limits.filter(Number.isFinite),days?.boleta??0)); return toYMD(d);
  })();

  const corregiblesFvIds = useMemo(()=>
    rechazos.filter(r=>requiereCorreccionFecha(r,days)&&r.FV_ID_FACTURACION)
            .map(r=>r.FV_ID_FACTURACION)
  ,[rechazos,days]);

  const rechazosFiltrados = useMemo(()=>
    busquedaRec?rechazos.filter(x=>
      x.NOMBRE?.toLowerCase().includes(busquedaRec.toLowerCase())||
      x.Comprobante?.toLowerCase().includes(busquedaRec.toLowerCase())||
      x.Cliente?.toLowerCase().includes(busquedaRec.toLowerCase())||
      x.DNI?.toLowerCase().includes(busquedaRec.toLowerCase())):rechazos
  ,[rechazos,busquedaRec]);

  const safeDocPage=Math.min(docPage,Math.max(0,Math.ceil(rechazosFiltrados.length/20)-1));
  const visibleDocs=rechazosFiltrados.slice(safeDocPage*20,(safeDocPage+1)*20);
const subtituloHeader = desde === 'farmacia' ? 'Farmacia' : 'Economía';

  return (
    <>
      <Box className="monitor-page pharmacy-page" sx={{minHeight:'100vh',bgcolor:IOS.bg}}>
        <HeaderIOS 
          titulo="Monitor de Envíos" 
          subtitulo={subtituloHeader}   // ← reemplazá el string fijo
          onHome={()=> desde ? navigate(`/${desde}`) : navigate(`/${modulo}`)} onLogout={handleLogout}
          nombreCompleto={user?.nombreCompleto||user?.usuario||''}
          avatarLetra={(user?.nombreCompleto||user?.usuario||'U').charAt(0).toUpperCase()} />

        <Box sx={{maxWidth:1600,mx:'auto',px:{xs:2,sm:4},pt:2.5,pb:6}}>

          <PharmacyTabs value={tab} onChange={setTab} options={[{value:'ipress',label:'IPRESS y versiones'},{value:'resumen',label:'Sincronización'},{value:'rechazos',label:'Comprobantes',badge:totalRechazos||undefined}]}/>
          <Box className="monitor-intro">
            <span className="monitor-eyebrow">{tab==="resumen"?"Sincronización · Economía":tab==="rechazos"?"Comprobantes · Economía":"Versiones · Economía"}</span>
            <Typography component="h1">{tab==="resumen"?"Cada envío, bajo seguimiento":tab==="rechazos"?"Cada comprobante, en orden":"Tu red, al día"}</Typography>
            <Typography>{tab==="resumen"?"Consulta la actividad de tu red e identifica los establecimientos que necesitan atención.":tab==="rechazos"?"Revisa pendientes, corrige los datos necesarios y sigue el estado de cada comprobante.":"Consulta las versiones de Integra, RCSync y SISMED en cada establecimiento."}</Typography>
          </Box>
          {loadError&&<Alert severity="error" sx={{mb:2}}>{loadError}</Alert>}
          {tab==='ipress'&&<MonitorFleet rows={fleet} loading={fleetLoading} error={fleetError} onRefresh={loadFleet} onInspect={r=>{setBusquedaRec(r.nombre);setTab('rechazos');}}/>}
          {/* ── TAB RESUMEN ──────────────────────────────────────────────── */}
          {tab==='resumen'&&(
            <Box className="sync-dashboard">
              {/* Filtros fecha + refresh */}
              <Box className="sync-panel" sx={{bgcolor:IOS.surface,borderRadius:'24px',p:2,mb:2,boxShadow:'0 1px 4px rgba(0,0,0,0.07)',border:`1px solid ${IOS.separator}`,display:'flex',flexWrap:'wrap',gap:1.5,alignItems:'flex-end'}}>
                {[['Desde',fechaInicio,setFechaInicio],['Hasta',fechaFin,setFechaFin]].map(([lbl,val,set])=>(
                  <Box key={lbl}>
                    <Lbl>{lbl}</Lbl>
                    <DatePickerIOS value={val} onChange={set} w={140} />
                  </Box>
                ))}
                <Box sx={{display:'flex',alignItems:'flex-end',gap:1}}>
                  <BtnRefresh onClick={cargarTodo} loading={cargando} />
                  {ultimaAct&&<Typography sx={{fontSize:'0.68rem',color:IOS.label2,whiteSpace:'nowrap',pb:0.5}}>
                    {ultimaAct.toLocaleTimeString('es-PE',{hour:'2-digit',minute:'2-digit',second:'2-digit'})}
                  </Typography>}
                </Box>
              </Box>

              {/* KPIs principales */}
              <Box sx={{display:'grid',gridTemplateColumns:{xs:'1fr 1fr',sm:'repeat(4,1fr)'},gap:2.5,mb:3}}>
                <KpiCard label="Eventos registrados" value={totalEventos.toLocaleString()} color={IOS.blue}
                  icon={<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke={IOS.blue} strokeWidth="1.8" strokeLinecap="round"><rect x="3" y="3" width="18" height="18" rx="2"/><path d="M9 9h6M9 12h6M9 15h4"/></svg>}/>
                <KpiCard label="Sincronizaciones correctas" value={totalOk.toLocaleString()} color={IOS.green} pct={tasaExito}
                  icon={<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke={IOS.green} strokeWidth="1.8" strokeLinecap="round"><path d="M9 11l3 3L22 4"/><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"/></svg>}/>
                <KpiCard label="Eventos con error" value={totalErr.toLocaleString()} color={IOS.red}
                  sub={totalEventos>0?`${((totalErr/totalEventos)*100).toFixed(1)}% del total`:''}
                  icon={<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke={IOS.red} strokeWidth="1.8" strokeLinecap="round"><circle cx="12" cy="12" r="10"/><path d="M12 8v4M12 16h.01"/></svg>}/>
                <KpiCard label="IPRESS con actividad" value={ipress.length} color={IOS.purple}
                  sub={`${ipress.filter(x=>x.ESTADO==='OK').length} sin errores`}
                  icon={<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke={IOS.purple} strokeWidth="1.8" strokeLinecap="round"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>}/>
              </Box>

              <Box className="sync-status-bar">
                <Box className="sync-status-label"><Typography sx={{fontWeight:700}}>Estado por establecimiento</Typography><Typography variant="caption" color="text.secondary">{moduloSel} · selecciona un estado para filtrar</Typography></Box>
                <Box className="sync-status-options">
                  {[['AL DIA','Al día',cntAlDia],['EN RIESGO','En riesgo',cntRiesgo],['ATRASADO','Atrasados',cntAtrasado],['SIN ENVIO','Sin envío',cntSinEnv]].map(([state,label,count])=><button key={state} type="button" aria-pressed={estadoFiltro===state} onClick={()=>setEstadoFiltro(prev=>prev===state?null:state)} style={{'--state-color':ESTADO_CFG[state].dot}}><span className="sync-state-dot"/><span>{label}</span><strong>{count}</strong></button>)}
                </Box>
              </Box>
              {/* Gráficos */}
              <Box sx={{display:'grid',gridTemplateColumns:{xs:'1fr',md:'1.4fr 1fr'},gap:2.5,mb:3,alignItems:'stretch'}}>
                <Box sx={{bgcolor:IOS.surface,borderRadius:'24px',p:2.5,boxShadow:'0 1px 4px rgba(0,0,0,0.07)',border:`1px solid ${IOS.separator}`,
                  display:'flex',flexDirection:'column',minWidth:0,overflow:'hidden'}}>
                  <Box sx={{display:'flex',alignItems:'center',gap:1.2,mb:2}}>
                    <Box sx={{width:36,height:36,borderRadius:'11px',bgcolor:`${IOS.blue}14`,display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0}}>
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke={IOS.blue} strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round"><path d="M3 3v18h18"/><path d="M18.7 8l-5.1 5.1-2.8-2.8L6 15.1"/></svg>
                    </Box>
                    <Box sx={{minWidth:0}}>
                      <Typography sx={{fontWeight:700,fontSize:'0.88rem',color:IOS.label}}>Evolución de la sincronización</Typography>
                      <Typography sx={{fontSize:'0.68rem',color:IOS.label2}}>Últimos 10 días · selecciona un día para ver su actividad</Typography>
                    </Box>
                  </Box>
                  <Box sx={{height:280,position:'relative',width:'100%',minWidth:0}}><MonitorChart data={tendencia} onSelect={row=>{const date=String(row.DIA).slice(0,10);setFechaInicio(date);setFechaFin(date);}}/></Box>
                </Box>
                <Box sx={{bgcolor:IOS.surface,borderRadius:'24px',p:2.5,boxShadow:'0 1px 4px rgba(0,0,0,0.07)',border:`1px solid ${IOS.separator}`,
                  display:'flex',flexDirection:'column',minWidth:0,overflow:'hidden'}}>
                  <Box sx={{display:'flex',alignItems:'center',gap:1.2,mb:2}}>
                    <Box sx={{width:36,height:36,borderRadius:'11px',bgcolor:`${IOS.purple}14`,display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0}}>
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke={IOS.purple} strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="12" width="5" height="9"/><rect x="10" y="7" width="5" height="14"/><rect x="17" y="3" width="5" height="18"/></svg>
                    </Box>
                    <Box sx={{minWidth:0}}>
                      <Typography sx={{fontWeight:700,fontSize:'0.88rem',color:IOS.label}}>Actividad por módulo</Typography>
                      <Typography sx={{fontSize:'0.68rem',color:IOS.label2}}>Compara resultados y selecciona un módulo</Typography>
                    </Box>
                  </Box>
                  <Box sx={{height:280,position:'relative',width:'100%',minWidth:0}}><MonitorChart bar data={modulos} onSelect={row=>{if(MODULOS.includes(row.MODULO))setModuloSel(row.MODULO);}}/></Box>
                </Box>
              </Box>

              {/* Tabla IPRESS estado envío */}
              <Box sx={{bgcolor:IOS.surface,borderRadius:'24px',boxShadow:'0 1px 4px rgba(0,0,0,0.07)',border:`1px solid ${IOS.separator}`,overflow:'hidden',mb:2}}>
                <Box sx={{px:2.5,py:2,borderBottom:`1px solid ${IOS.separator}`,display:'flex',alignItems:'center',justifyContent:'space-between',flexWrap:'wrap',gap:2.5,alignItems:'start'}}>
                  <Box>
                    <Typography sx={{fontWeight:700,fontSize:'0.88rem',color:IOS.label}}>Seguimiento por IPRESS</Typography>
                    <Typography sx={{fontSize:'0.7rem',color:IOS.label2}}>
                      Último envío del módulo <strong style={{color:IOS.label}}>{moduloSel}</strong>, por establecimiento
                    </Typography>
                    {estadoFiltro && (
                      <Box onClick={()=>setEstadoFiltro(null)}
                        sx={{display:'inline-flex',alignItems:'center',gap:0.5,mt:0.6,px:1,py:0.25,borderRadius:'20px',
                          bgcolor:`${ESTADO_CFG[estadoFiltro].dot}15`,border:`1px solid ${ESTADO_CFG[estadoFiltro].dot}40`,cursor:'pointer'}}>
                        <Typography sx={{fontSize:'0.72rem',fontWeight:700,color:ESTADO_CFG[estadoFiltro].dot}}>
                          Filtrando: {ESTADO_CFG[estadoFiltro].label} ×
                        </Typography>
                      </Box>
                    )}
                  </Box>
                  <Box sx={{display:'flex',gap:1.5,alignItems:'center',flexWrap:'wrap'}}>
                    <Sel value={moduloSel} onChange={e=>setModuloSel(e.target.value)} w={150}>
                      {MODULOS.map(m=><option key={m} value={m}>{m}</option>)}
                    </Sel>
                    <Box sx={{position:'relative'}}>
                      <Box sx={{position:'absolute',left:9,top:'50%',transform:'translateY(-50%)',pointerEvents:'none',color:IOS.label2}}>
                        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35"/></svg>
                      </Box>
                      <input placeholder="Buscar IPRESS..." value={busqueda} onChange={e=>setBusqueda(e.target.value)}
                        aria-label="Buscar IPRESS" style={{height:40,width:220,paddingLeft:26,paddingRight:10,border:`1px solid ${IOS.separator}`,borderRadius:8,fontSize:'0.78rem',color:IOS.label,backgroundColor:IOS.surface,outline:'none',fontFamily:'inherit',boxSizing:'border-box'}}
                        onFocus={e=>e.target.style.borderColor=IOS.blue}
                        onBlur={e=>e.target.style.borderColor=IOS.separator}/>
                    </Box>
                  </Box>
                </Box>

                {/* Móvil */}
                <Box sx={{display:{xs:'block',md:'none'}}}>
                  {ipressEnvFiltrada.length===0
                    ?<Box sx={{py:4,textAlign:'center'}}><Typography sx={{color:IOS.label2,fontSize:'0.82rem'}}>Sin datos</Typography></Box>
                    :syncVisible.map((row,i)=><IpressCard key={i} row={row}/>)
                  }
                </Box>
                {/* Desktop */}
                <Box sx={{display:{xs:'none',md:'block'},overflowX:'auto','&::-webkit-scrollbar':{width:3,height:3},'&::-webkit-scrollbar-thumb':{bgcolor:IOS.separator,borderRadius:4}}}>
                  <table style={{width:'100%',borderCollapse:'collapse',minWidth:600}}>
                    <colgroup><col style={{width:40}}/><col/><col style={{width:150}}/><col style={{width:100}}/><col style={{width:110}}/></colgroup>
                    <thead><tr><TH>#</TH><TH>IPRESS</TH><TH>Último Envío</TH><TH right>Días sin Envío</TH><TH>Estado</TH></tr></thead>
                    <tbody>
                      {ipressEnvFiltrada.length===0
                        ?<tr><td colSpan={5} style={{padding:'30px',textAlign:'center',color:IOS.label2,fontSize:'0.82rem'}}>Sin datos</td></tr>
                        :syncVisible.map((row,i)=>{
                          const dias=row.DIAS_SIN_ENVIO;
                          const dc=dias===null?IOS.label2:dias<=2?IOS.green:dias===3?IOS.orange:IOS.red;
                          return(
                            <tr key={i} style={{borderBottom:`1px solid ${IOS.separator}`,backgroundColor:IOS.surface,transition:'background 0.1s'}}
                              onMouseEnter={e=>e.currentTarget.style.backgroundColor=IOS.bg}
                              onMouseLeave={e=>e.currentTarget.style.backgroundColor=IOS.surface}>
                              <td style={{padding:'7px 8px',fontSize:'0.68rem',color:IOS.label2}}>{syncSafePage*10+i+1}</td>
                              <td style={{padding:'7px 8px',fontSize:'0.74rem',fontWeight:600,color:IOS.label}}>{row.IPRESS}</td>
                              <td style={{padding:'7px 8px',fontSize:'0.7rem',color:IOS.label2}}>
                                {row.ULTIMO_ENVIO?<>{fmtFecha(row.ULTIMO_ENVIO)} <span style={{color:IOS.label2,fontSize:'0.65rem'}}>{fmtHora(row.ULTIMO_ENVIO)}</span></>:'—'}
                              </td>
                              <td style={{padding:'7px 8px',textAlign:'right'}}>
                                <span style={{fontWeight:800,fontSize:'0.78rem',color:dc}}>{dias!==null&&dias!==undefined?`${dias}d`:'—'}</span>
                              </td>
                              <td style={{padding:'7px 8px'}}><PillEstado estado={row.ESTADO} sm/></td>
                            </tr>
                          );
                        })
                      }
                    </tbody>
                  </table>
                </Box>
                <TablePagination component="div" count={ipressEnvFiltrada.length} page={syncSafePage} rowsPerPage={10} rowsPerPageOptions={[10]} onPageChange={(_,page)=>setSyncPage(page)} labelRowsPerPage="Por página" labelDisplayedRows={({from,to,count})=>`${from}–${to} de ${count} IPRESS`}/>
                {/* Leyenda */}
                <Box sx={{px:2.5,py:1.2,borderTop:`1px solid ${IOS.separator}`,bgcolor:IOS.bg,display:'flex',gap:2,flexWrap:'wrap',alignItems:'center'}}>
                  {Object.entries(ESTADO_CFG).map(([k,v])=>{
                    const cnt=ipressEnv.filter(x=>x.ESTADO===k).length;
                    return(
                      <Box key={k} sx={{display:'flex',alignItems:'center',gap:0.6}}>
                        <Box sx={{width:6,height:6,borderRadius:'50%',bgcolor:v.dot}}/>
                        <Typography sx={{fontSize:'0.72rem',color:IOS.label2}}>{v.label}: <strong style={{color:IOS.label}}>{cnt}</strong></Typography>
                      </Box>
                    );
                  })}
                  <Box sx={{flex:1}}/>
                  <Typography sx={{fontSize:'0.72rem',color:IOS.label2}}>{ipressEnvFiltrada.length} establecimientos</Typography>
                </Box>
              </Box>

              {/* Tablas IPRESS periodo + Errores */}
              <Box sx={{display:'grid',gridTemplateColumns:{xs:'1fr',lg:'1fr 1.5fr'},gap:1.5}}>
                {/* IPRESS periodo */}
                <Box sx={{bgcolor:IOS.surface,borderRadius:'24px',boxShadow:'0 1px 4px rgba(0,0,0,0.07)',border:`1px solid ${IOS.separator}`,overflow:'hidden'}}>
                  <Box sx={{px:2.5,py:2,borderBottom:`1px solid ${IOS.separator}`}}>
                    <Typography sx={{fontWeight:700,fontSize:'0.88rem',color:IOS.label}}>Resultados del periodo</Typography>
                    <Typography sx={{fontSize:'0.7rem',color:IOS.label2}}>Todos los módulos combinados, {fmtFecha(fechaInicio)} – {fmtFecha(fechaFin)} · toca una fila con errores para filtrar</Typography>
                  </Box>
                  <Box sx={{overflowX:'auto','&::-webkit-scrollbar':{width:3},'&::-webkit-scrollbar-thumb':{bgcolor:IOS.separator,borderRadius:4}}}>
                    <table style={{width:'100%',borderCollapse:'collapse'}}>
                      <thead><tr><TH>IPRESS</TH><TH right>OK</TH><TH right>Errores</TH><TH center>Estado</TH></tr></thead>
                      <tbody>
                        {ipress.length===0
                          ?<tr><td colSpan={4} style={{padding:'24px',textAlign:'center',color:IOS.label2,fontSize:'0.78rem'}}>Sin datos</td></tr>
                          :ipress.map((row,i)=>{
                            const tieneErr = row.ERRORES>0;
                            const sel = ipressFiltroErr===row.IPRESS;
                            return (
                            <tr key={i}
                              onClick={()=>{ if(tieneErr) setIpressFiltroErr(prev=>prev===row.IPRESS?null:row.IPRESS); }}
                              style={{borderBottom:`1px solid ${IOS.separator}`,backgroundColor:sel?`${IOS.red}0A`:IOS.surface,
                                transition:'background 0.1s',cursor:tieneErr?'pointer':'default'}}
                              onMouseEnter={e=>{ if(!sel) e.currentTarget.style.backgroundColor=tieneErr?'#FFF8E6':IOS.bg; }}
                              onMouseLeave={e=>e.currentTarget.style.backgroundColor=sel?`${IOS.red}0A`:IOS.surface}>
                              <td style={{padding:'7px 8px',fontSize:'0.72rem',color:IOS.label,fontWeight:500}}>{row.IPRESS}</td>
                              <td style={{padding:'7px 8px',fontSize:'0.72rem',color:IOS.green,fontWeight:700,textAlign:'right'}}>{row.OK}</td>
                              <td style={{padding:'7px 8px',fontSize:'0.72rem',color:tieneErr?IOS.red:IOS.label2,fontWeight:700,textAlign:'right'}}>{row.ERRORES}</td>
                              <td style={{padding:'7px 8px',textAlign:'center'}}>
                                <Box sx={{display:'inline-flex',px:0.8,py:0.2,borderRadius:'20px',
                                  bgcolor:row.ESTADO==='OK'?'#EDFAF2':row.ESTADO==='PARCIAL'?'#FFF8E6':'#FFF0EF',
                                  border:`1px solid ${row.ESTADO==='OK'?'#B7EFD0':row.ESTADO==='PARCIAL'?'#FFE9A0':'#FFD4D1'}`}}>
                                  <Typography sx={{fontSize:'0.72rem',fontWeight:700,color:row.ESTADO==='OK'?'#1A6B3C':row.ESTADO==='PARCIAL'?'#8B6914':'#C0392B'}}>{row.ESTADO}</Typography>
                                </Box>
                              </td>
                            </tr>
                            );
                          })
                        }
                      </tbody>
                    </table>
                  </Box>
                </Box>

                {/* Errores recientes */}
                <Box sx={{bgcolor:IOS.surface,borderRadius:'24px',boxShadow:'0 1px 4px rgba(0,0,0,0.07)',border:`1px solid ${IOS.separator}`,overflow:'hidden'}}>
                  <Box sx={{px:2.5,py:2,borderBottom:`1px solid ${IOS.separator}`,display:'flex',alignItems:'center',justifyContent:'space-between',flexWrap:'wrap',gap:1}}>
                    <Box>
                      <Typography sx={{fontWeight:700,fontSize:'0.88rem',color:IOS.label}}>Incidencias para revisar</Typography>
                      <Typography sx={{fontSize:'0.7rem',color:IOS.label2}}>Detalle de eventos fallidos</Typography>
                      {ipressFiltroErr && (
                        <Box onClick={()=>setIpressFiltroErr(null)}
                          sx={{display:'inline-flex',alignItems:'center',gap:0.5,mt:0.6,px:1,py:0.25,borderRadius:'20px',
                            bgcolor:`${IOS.red}12`,border:`1px solid ${IOS.red}30`,cursor:'pointer'}}>
                          <Typography sx={{fontSize:'0.72rem',fontWeight:700,color:IOS.red}}>Filtrando: {ipressFiltroErr} ×</Typography>
                        </Box>
                      )}
                    </Box>
                    {erroresFiltrados.length>0&&(
                      <Box sx={{display:'inline-flex',px:1,py:0.3,borderRadius:'20px',bgcolor:'#FFF0EF',border:'1px solid #FFD4D1'}}>
                        <Typography sx={{fontSize:'0.65rem',fontWeight:700,color:IOS.red}}>{erroresFiltrados.length} errores</Typography>
                      </Box>
                    )}
                  </Box>
                  {/* Móvil */}
                  <Box sx={{display:{xs:'block',md:'none'},'&::-webkit-scrollbar':{width:3},'&::-webkit-scrollbar-thumb':{bgcolor:IOS.separator,borderRadius:4}}}>
                    {erroresFiltrados.length===0
                      ?<Box sx={{py:6,textAlign:'center'}}>
                          <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke={IOS.green} strokeWidth="1.8" strokeLinecap="round"><path d="M9 11l3 3L22 4"/><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"/></svg>
                          <Typography sx={{color:IOS.label2,fontSize:'0.78rem',mt:1}}>{ipressFiltroErr?`Sin errores para ${ipressFiltroErr}`:'Sin errores en el periodo'}</Typography>
                        </Box>
                      :erroresFiltrados.map((row,i)=><ErrorCard key={i} row={row} onVerDetalle={setErrorDetalle}/>)
                    }
                  </Box>
                  {/* Desktop */}
                  <Box sx={{display:{xs:'none',md:'block'},overflowX:'auto','&::-webkit-scrollbar':{width:3,height:3},'&::-webkit-scrollbar-thumb':{bgcolor:IOS.separator,borderRadius:4}}}>
                    <table style={{width:'100%',borderCollapse:'collapse',minWidth:560}}>
                      <thead><tr><TH>IPRESS</TH><TH>Módulo</TH><TH>Evento</TH><TH>Detalle</TH><TH>Fecha</TH></tr></thead>
                      <tbody>
                        {erroresFiltrados.length===0
                          ?<tr><td colSpan={5} style={{padding:'30px',textAlign:'center'}}>
                              <Box sx={{display:'flex',flexDirection:'column',alignItems:'center',gap:1}}>
                                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke={IOS.green} strokeWidth="1.8" strokeLinecap="round"><path d="M9 11l3 3L22 4"/><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"/></svg>
                                <Typography sx={{color:IOS.label2,fontSize:'0.78rem'}}>{ipressFiltroErr?`Sin errores para ${ipressFiltroErr}`:'Sin errores en el periodo'}</Typography>
                              </Box>
                            </td></tr>
                          :erroresFiltrados.map((row,i)=>(
                            <tr key={i} style={{borderBottom:`1px solid ${IOS.separator}`,backgroundColor:IOS.surface,transition:'background 0.1s'}}
                              onMouseEnter={e=>e.currentTarget.style.backgroundColor='#FFF8E6'}
                              onMouseLeave={e=>e.currentTarget.style.backgroundColor=IOS.surface}>
                              <td style={{padding:'7px 8px',fontSize:'0.7rem',color:IOS.label,fontWeight:500,whiteSpace:'nowrap'}}>{row.IPRESS}</td>
                              <td style={{padding:'7px 8px'}}>
                                <Box sx={{display:'inline-flex',px:0.7,py:0.2,borderRadius:'6px',bgcolor:`${IOS.purple}12`,border:`1px solid ${IOS.purple}25`}}>
                                  <Typography sx={{fontSize:'0.72rem',fontWeight:700,color:IOS.purple}}>{row.MODULO}</Typography>
                                </Box>
                              </td>
                              <td style={{padding:'7px 8px',fontSize:'0.7rem',color:IOS.label}}>{row.EVENTO}</td>
                              <td style={{padding:'7px 8px',maxWidth:160}}>
                                <Box sx={{display:'flex',alignItems:'center',gap:0.6}}>
                                  <span style={{flex:1,minWidth:0,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap',fontSize:'0.68rem',color:IOS.red}}>{row.DETALLE}</span>
                                  {row.DETALLE&&(
                                    <Box component="button" onClick={()=>setErrorDetalle(row)}
                                      sx={{width:20,height:20,borderRadius:'6px',border:'none',bgcolor:`${IOS.red}12`,cursor:'pointer',
                                        display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0,'&:hover':{bgcolor:`${IOS.red}22`}}}>
                                      <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke={IOS.red} strokeWidth="2.2" strokeLinecap="round"><path d="M15 3h6v6M9 21H3v-6M21 3l-7 7M3 21l7-7"/></svg>
                                    </Box>
                                  )}
                                </Box>
                              </td>
                              <td style={{padding:'7px 8px',fontSize:'0.65rem',color:IOS.label2,whiteSpace:'nowrap'}}>{fmtFecha(row.FECHA)} {fmtHora(row.FECHA)}</td>
                            </tr>
                          ))
                        }
                      </tbody>
                    </table>
                  </Box>
                </Box>
              </Box>
            </Box>
          )}

          {/* ── TAB RECHAZOS ─────────────────────────────────────────────── */}
          {tab==='rechazos'&&(
            <>
              {accessError&&<Alert severity="error" sx={{mb:2}}>{accessError}</Alert>}
              {!canSend&&!accessError&&<Alert severity="info" sx={{mb:2}}>Vista de consulta. Solo los administradores pueden enviar o corregir comprobantes.</Alert>}
              {/* Filtro + refresh */}
              <Box sx={{bgcolor:IOS.surface,borderRadius:'24px',p:2,mb:2,boxShadow:'0 1px 4px rgba(0,0,0,0.07)',border:`1px solid ${IOS.separator}`,display:'flex',flexWrap:'wrap',gap:1.5,alignItems:'flex-end'}}>
                <Box sx={{flex:'1 1 280px',maxWidth:380}}>
                  <Lbl>Buscar</Lbl>
                  <Box sx={{position:'relative'}}>
                    <Box sx={{position:'absolute',left:9,top:'50%',transform:'translateY(-50%)',pointerEvents:'none',color:IOS.label2}}>
                      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35"/></svg>
                    </Box>
                    <input placeholder="IPRESS, comprobante, cliente o DNI..." value={busquedaRec} onChange={e=>setBusquedaRec(e.target.value)}
                      style={{width:'100%',height:34,paddingLeft:26,paddingRight:10,border:`1px solid ${IOS.separator}`,borderRadius:8,fontSize:'0.8rem',color:IOS.label,backgroundColor:IOS.surface,outline:'none',fontFamily:'inherit',boxSizing:'border-box'}}
                      onFocus={e=>e.target.style.borderColor=IOS.blue}
                      onBlur={e=>e.target.style.borderColor=IOS.separator}/>
                  </Box>
                </Box>
                <Box sx={{display:'flex',alignItems:'flex-end',gap:1}}>
                  <BtnRefresh onClick={cargarRechazos} loading={cargandoRec}/>
                  {ultimaActRec&&<Typography sx={{fontSize:'0.68rem',color:IOS.label2,pb:0.5,whiteSpace:'nowrap'}}>
                    {ultimaActRec.toLocaleTimeString('es-PE',{hour:'2-digit',minute:'2-digit',second:'2-digit'})}
                  </Typography>}
                </Box>
              </Box>

              {/* Enviar Pendientes — en el lugar del banner, siempre visible cuando hay pendientes */}
              {canSend && (
                <Box id="panel-envio-masivo" sx={{mb:2}}>
                  <Box sx={{display:'flex',alignItems:'center',gap:1,mb:1.5}}>
                    <Box sx={{width:4,height:16,borderRadius:'4px',bgcolor:IOS.green}}/>
                    <Typography sx={{fontSize:'0.9rem',fontWeight:700,color:IOS.label}}>Enviar Pendientes</Typography>
                  </Box>
                  <EnvioMasivoPanel showCleanup={false} canSend={canSend} idUE={ueId} api={api} onEnviado={cargarRechazos} refreshTrigger={envioRefreshKey} onEstadoEnvioChange={setEnvioEnCurso} />
                </Box>
              )}

              {/* KPIs rechazos */}
              <Box sx={{display:'grid',gridTemplateColumns:{xs:'1fr 1fr',sm:'repeat(4,1fr)'},gap:1.5,mb:2}}>
                <KpiCard label="Total Pendientes" value={totalRechazos.toLocaleString()} color={IOS.red}
                  icon={<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke={IOS.red} strokeWidth="1.8" strokeLinecap="round"><circle cx="12" cy="12" r="10"/><path d="M12 8v4M12 16h.01"/></svg>}/>
                <KpiCard label="IPRESS Afectadas" value={ipressConRec} color={IOS.orange}
                  sub={`de ${ipress.length} total`}
                  icon={<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke={IOS.orange} strokeWidth="1.8" strokeLinecap="round"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>}/>
                <KpiCard label="Monto Pendiente" color={IOS.blue}
                  value={`S/${totalPendiente.toLocaleString('es-PE',{minimumFractionDigits:2,maximumFractionDigits:2})}`}
                  icon={<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke={IOS.blue} strokeWidth="1.8" strokeLinecap="round"><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg>}/>
                <KpiCard label="Tipos CPE" value={tiposCPE.length} color={IOS.purple}
                  sub={tiposCPE.join(' · ')}
                  icon={<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke={IOS.purple} strokeWidth="1.8" strokeLinecap="round"><rect x="3" y="3" width="18" height="18" rx="2"/><path d="M9 9h6M9 12h6M9 15h4"/></svg>}/>
              </Box>

              {canSend&&<MonitorCleanup api={api} idUE={ueId} disabled={envioEnCurso} onComplete={()=>{cargarRechazos();setEnvioRefreshKey(k=>k+1);}}>
              {(corregiblesFvIds.length>0||seleccionados.size>0)&&<Box sx={{...maintenanceRowSx,borderBottom:'1px solid #edf1f6'}}>
                <Box sx={{display:'flex',alignItems:'center',gap:1.5}}>
                  <Box sx={{width:36,height:36,borderRadius:'11px',bgcolor:'#edf3fa',color:'#6483a5',display:'grid',placeItems:'center',flexShrink:0}}><svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round"><rect x="3" y="4" width="18" height="18" rx="3"/><path d="M16 2v4M8 2v4M3 10h18M8 15h3"/></svg></Box>
                  <Box><Typography sx={{fontWeight:650,fontSize:13,color:'#354b65'}}>Fechas de comprobantes</Typography><Typography sx={{fontSize:12,color:'#7b899b',mt:.3}}>{seleccionados.size>0?seleccionados.size+' seleccionados para revisar':corregiblesFvIds.length+' requieren revisar su fecha'}</Typography></Box>
                </Box>
                <Box sx={{display:'flex',gap:1,flexWrap:'wrap'}}>
                  {seleccionados.size>0?<><Button disabled={envioEnCurso} sx={{...maintenanceButtonSx,bgcolor:'#fff',color:'#748397'}} onClick={()=>setSeleccionados(new Set())}>Deseleccionar</Button><Button disabled={envioEnCurso} sx={maintenanceButtonSx} onClick={()=>{setNuevaFechaLote('');setModalLote(true);}}>Cambiar fecha en lote</Button></>:<Button disabled={envioEnCurso} sx={maintenanceButtonSx} onClick={()=>setSeleccionados(new Set(corregiblesFvIds))}>Seleccionar comprobantes</Button>}
                </Box>
              </Box>}
              </MonitorCleanup>}

              {/* Tabla rechazos */}
              <Box sx={{bgcolor:IOS.surface,borderRadius:'24px',boxShadow:'0 1px 4px rgba(0,0,0,0.07)',border:`1px solid ${IOS.separator}`,overflow:'hidden',position:'relative'}}>
                <Box sx={{px:2.5,py:2,borderBottom:`1px solid ${IOS.separator}`,display:'flex',alignItems:'center',justifyContent:'space-between'}}>
                  <Box>
                    <Typography sx={{fontWeight:700,fontSize:'0.88rem',color:IOS.label}}>Comprobantes Rechazados / Pendientes</Typography>
                    <Typography sx={{fontSize:'0.7rem',color:IOS.label2}}>CPEs con estado distinto a ENVIADO en SUNAT</Typography>
                  </Box>
                  {rechazosFiltrados.length>0&&(
                    <Box sx={{display:'inline-flex',px:1,py:0.3,borderRadius:'20px',bgcolor:'#FFF0EF',border:'1px solid #FFD4D1'}}>
                      <Typography sx={{fontSize:'0.65rem',fontWeight:700,color:IOS.red}}>{rechazosFiltrados.length} registros</Typography>
                    </Box>
                  )}
                </Box>

                {envioEnCurso && (
                  <Box sx={{position:'absolute',left:0,right:0,bottom:0,height:'calc(100% - 60px)',zIndex:5,
                    display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',gap:1.2,
                    bgcolor:'rgba(255,255,255,0.55)',backdropFilter:'blur(1px)'}}>
                    <CircularProgress size={30} sx={{color:IOS.green}}/>
                    <Typography sx={{fontSize:'0.85rem',fontWeight:700,color:IOS.label}}>Enviando a SUNAT…</Typography>
                    <Typography sx={{fontSize:'0.7rem',color:IOS.label2}}>La tabla se actualizará al terminar</Typography>
                  </Box>
                )}

                <Box sx={{filter:envioEnCurso?'blur(3px)':'none',pointerEvents:envioEnCurso?'none':'auto',
                  transition:'filter 0.3s ease',userSelect:envioEnCurso?'none':'auto'}}>

                {/* Móvil */}
                <Box sx={{display:{xs:'block',md:'none'}}}>
                  {cargandoRec
                    ?<Box sx={{py:6,textAlign:'center'}}><CircularProgress size={24} sx={{color:IOS.blue}}/></Box>
                    :rechazosFiltrados.length===0
                      ?<Box sx={{py:6,textAlign:'center'}}>
                          <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke={IOS.green} strokeWidth="1.8" strokeLinecap="round"><path d="M9 11l3 3L22 4"/><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"/></svg>
                          <Typography sx={{color:IOS.label2,fontSize:'0.82rem',mt:1}}>No hay comprobantes en esta consulta</Typography>
                        </Box>
                      :visibleDocs.map((row,i)=><Box key={i}><RechazoCard row={row} i={i}/>{canSend&&<Box sx={{display:"flex",gap:1,flexWrap:"wrap",px:2,pb:2}}>{requiereCorreccionFecha(row,days)&&row.FV_ID_FACTURACION&&<><Button onClick={()=>toggleSeleccion(row.FV_ID_FACTURACION)}>{seleccionados.has(row.FV_ID_FACTURACION)?"Quitar selección":"Seleccionar"}</Button><Button onClick={()=>{setModalFecha(row);setNuevaFecha("");}}>Cambiar fecha</Button></>}{esNombreInvalido(row.Cliente)&&row.DNI&&<Button onClick={()=>{setModalNombre(row);setResultadoNombre(null);setNombreManual(row.Cliente||"");setHistorialFallo(false);setReniecFallo(false);}}>Corregir cliente</Button>}</Box>}</Box>)
                  }
                </Box>

                {/* Desktop */}
                <Box sx={{display:{xs:'none',md:'block'},overflowX:'auto','&::-webkit-scrollbar':{width:4,height:4},'&::-webkit-scrollbar-thumb':{bgcolor:IOS.separator,borderRadius:4}}}>
                  <table className="pending-documents-table">
 <thead><tr><th>{canSend&&<Checkbox size="small" inputProps={{'aria-label':'Seleccionar comprobantes que requieren cambio de fecha'}} checked={corregiblesFvIds.length>0&&corregiblesFvIds.every(id=>seleccionados.has(id))} indeterminate={corregiblesFvIds.some(id=>seleccionados.has(id))&&!corregiblesFvIds.every(id=>seleccionados.has(id))} disabled={!corregiblesFvIds.length} onChange={()=>toggleSeleccionarTodos(corregiblesFvIds)}/>}</th><th>Establecimiento</th><th>Comprobante / fecha</th><th>Cliente / documento</th><th>Total</th><th>Estado</th><th>Acciones</th></tr></thead>
 <tbody>{cargandoRec?<tr><td colSpan={7} style={{textAlign:'center',padding:40}}><CircularProgress size={24}/></td></tr>:!visibleDocs.length?<tr><td colSpan={7} style={{textAlign:'center',padding:32}}>No hay comprobantes para esta búsqueda.</td></tr>:visibleDocs.map((row,i)=><React.Fragment key={row.FV_ID_FACTURACION||row.Comprobante+i}>
 <tr className={seleccionados.has(row.FV_ID_FACTURACION)?'is-selected':''}>
 <td>{canSend&&requiereCorreccionFecha(row,days)&&row.FV_ID_FACTURACION&&<Checkbox size="small" checked={seleccionados.has(row.FV_ID_FACTURACION)} onChange={()=>toggleSeleccion(row.FV_ID_FACTURACION)} inputProps={{'aria-label':'Seleccionar '+row.Comprobante}}/>}</td>
 <td><strong>{row.NOMBRE}</strong><small>{row.Fuente||'SISMED'}{row.FP?' · '+row.FP:''}</small></td>
 <td><strong>{row.Comprobante}</strong><small>{row.TipoCPE}</small><small>{row.Fecha}</small></td>
 <td><strong>{row.Cliente||'Sin nombre'}</strong><small>{row.DNI||'Sin documento'}</small></td>
 <td className="pending-amount">S/ {Number(row.Total||0).toLocaleString('es-PE',{minimumFractionDigits:2,maximumFractionDigits:2})}</td>
 <td><span className={'pending-state '+(row.Estado==='RECHAZADO'?'rejected':'')}>{row.Estado}</span></td>
 <td><div className="pending-row-actions">{canSend&&requiereCorreccionFecha(row,days)&&row.FV_ID_FACTURACION&&<Button size="small" onClick={()=>{setModalFecha(row);setNuevaFecha('');}}>Cambiar fecha</Button>}{canSend&&esNombreInvalido(row.Cliente)&&row.DNI&&<Button size="small" onClick={()=>{setModalNombre(row);setResultadoNombre(null);setNombreManual('CLIENTE EVENTUAL');setHistorialFallo(false);setReniecFallo(false);}}>Corregir cliente</Button>}<Button size="small" onClick={()=>setErrorDetalle({IPRESS:row.NOMBRE,MODULO:row.TipoCPE,FECHA:row.Fecha,EVENTO:'Comprobante '+row.Comprobante,DETALLE:'Cliente: '+row.Cliente+' · DNI: '+row.DNI+'\n\n'+(row.LOG_MENSAJE||'Sin mensaje adicional')})}>Ver detalle</Button></div></td>
 </tr>
 <tr className="pending-message-row"><td colSpan={7}><div className={'pending-message '+(row.Estado==='RECHAZADO'?'rejected':'')}><span>{row.Estado==='RECHAZADO'?'Motivo del rechazo':'Información del comprobante'}</span><p>{row.LOG_MENSAJE||'Sin mensaje adicional.'}</p></div></td></tr>
 </React.Fragment>)}</tbody>
 </table>
                </Box>

                <TablePagination component="div" count={rechazosFiltrados.length} page={safeDocPage} rowsPerPage={20} rowsPerPageOptions={[20]} onPageChange={(_,p)=>setDocPage(p)} labelRowsPerPage="Por página" labelDisplayedRows={({from,to,count})=>from+'–'+to+' de '+count}/>
                {rechazosFiltrados.length>0&&(
                  <Box sx={{px:2.5,py:1.2,borderTop:`1px solid ${IOS.separator}`,bgcolor:IOS.bg,display:'flex',justifyContent:'flex-end'}}>
                    <Typography sx={{fontSize:'0.72rem',color:IOS.label2}}>{rechazosFiltrados.length} comprobantes pendientes</Typography>
                  </Box>
                )}
                </Box>
              </Box>
            </>
          )}
        </Box>
      </Box>

      {/* Modal corregir fecha en LOTE */}
      {canSend && modalLote && (
        <Box sx={{position:'fixed',inset:0,zIndex:9999,bgcolor:'rgba(0,0,0,0.45)',display:'flex',alignItems:'center',justifyContent:'center',backdropFilter:'blur(6px)'}}
          onClick={()=>!corrigiendo&&setModalLote(false)}>
          <Box onClick={e=>e.stopPropagation()}
            sx={{bgcolor:IOS.surface,borderRadius:'20px',p:3,width:420,boxShadow:'0 24px 60px rgba(0,0,0,0.2)'}}>
            <Box sx={{display:'flex',alignItems:'center',gap:1.5,mb:2}}>
              <Box sx={{width:44,height:44,borderRadius:'12px',bgcolor:'#FFF8E6',border:'1px solid #FFE9A0',display:'flex',alignItems:'center',justifyContent:'center'}}>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={IOS.orange} strokeWidth="2" strokeLinecap="round"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
              </Box>
              <Box>
                <Typography sx={{fontSize:'0.95rem',fontWeight:800,color:IOS.label}}>Corregir fecha en lote</Typography>
                <Typography sx={{fontSize:'0.72rem',color:IOS.label2}}>{seleccionados.size} comprobantes seleccionados</Typography>
              </Box>
            </Box>
            <Box sx={{p:1.5,bgcolor:'#FFF8E6',borderRadius:'10px',border:'1px solid #FFE9A0',mb:2}}>
              <Typography sx={{fontSize:'0.75rem',color:'#8B6914',lineHeight:1.5}}>
                Se aplicará la misma nueva fecha a los {seleccionados.size} comprobantes seleccionados,
                eliminando sus registros de envío fallido para permitir el reenvío.
              </Typography>
            </Box>
            <Box sx={{mb:2.5}}>
              <Lbl>Nueva fecha de venta (para todos)</Lbl>
              <DatePickerIOS value={nuevaFechaLote} onChange={setNuevaFechaLote} minDate={minFechaCorreccion} maxDate={hoyYMD} />
            </Box>
            <Box sx={{display:'flex',gap:1}}>
              <Box component="button" onClick={()=>setModalLote(false)} disabled={corrigiendo}
                sx={{flex:1,height:40,borderRadius:'12px',border:`1px solid ${IOS.separator}`,bgcolor:IOS.bg,cursor:'pointer',fontSize:'0.82rem',fontWeight:600,color:IOS.label}}>
                Cancelar
              </Box>
              <Box component="button" onClick={corregirFechaLote} disabled={corrigiendo||!nuevaFechaLote}
                sx={{flex:1,height:40,borderRadius:'12px',border:'none',bgcolor:!nuevaFechaLote?'#E5E5EA':IOS.orange,
                  cursor:corrigiendo||!nuevaFechaLote?'default':'pointer',display:'flex',alignItems:'center',justifyContent:'center',gap:0.8,
                  transition:'all 0.2s','&:hover':{filter:'brightness(0.92)'}}}>
                {corrigiendo&&<CircularProgress size={14} sx={{color:'white'}}/>}
                <Typography sx={{fontSize:'0.82rem',fontWeight:700,color:!nuevaFechaLote?'#8E8E93':'white'}}>
                  {corrigiendo?'Corrigiendo...':`Corregir ${seleccionados.size} comprobantes`}
                </Typography>
              </Box>
            </Box>
          </Box>
        </Box>
      )}

      {/* Modal detalle de error */}
      {errorDetalle && (
        <Box sx={{position:'fixed',inset:0,zIndex:9999,bgcolor:'rgba(0,0,0,0.45)',display:'flex',alignItems:'center',justifyContent:'center',p:2,backdropFilter:'blur(6px)'}}
          onClick={()=>setErrorDetalle(null)}>
          <Box onClick={e=>e.stopPropagation()}
            sx={{bgcolor:IOS.surface,borderRadius:'20px',overflow:'hidden',width:460,maxWidth:'100%',boxShadow:'0 24px 60px rgba(0,0,0,0.2)'}}>
            <Box sx={{px:3,pt:2.5,pb:2,borderBottom:`1px solid ${IOS.separator}`,display:'flex',alignItems:'flex-start',justifyContent:'space-between',gap:2}}>
              <Box sx={{display:'flex',gap:1.5,alignItems:'flex-start'}}>
                <Box sx={{width:38,height:38,borderRadius:'11px',bgcolor:'#FFF0EF',display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0}}>
                  <svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke={IOS.red} strokeWidth="1.8" strokeLinecap="round"><circle cx="12" cy="12" r="10"/><path d="M12 8v4M12 16h.01"/></svg>
                </Box>
                <Box>
                  <Typography sx={{fontSize:'0.72rem',fontWeight:700,color:IOS.label2,letterSpacing:'0.07em',textTransform:'uppercase',mb:0.3}}>Detalle del Error</Typography>
                  <Typography sx={{fontSize:'0.9rem',fontWeight:700,color:IOS.label}}>{errorDetalle.IPRESS}</Typography>
                </Box>
              </Box>
              <Box component="button" onClick={()=>setErrorDetalle(null)}
                sx={{width:30,height:30,borderRadius:'50%',border:'none',bgcolor:'#E5E5EA',cursor:'pointer',flexShrink:0,
                  display:'flex',alignItems:'center',justifyContent:'center','&:hover':{bgcolor:'#D1D1D6'}}}>
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke={IOS.label} strokeWidth="2.5" strokeLinecap="round"><path d="M18 6L6 18M6 6l12 12"/></svg>
              </Box>
            </Box>
            <Box sx={{p:3}}>
              <Box sx={{display:'flex',gap:1,flexWrap:'wrap',mb:2}}>
                <Box sx={{display:'inline-flex',px:1,py:0.3,borderRadius:'20px',bgcolor:`${IOS.purple}12`,border:`1px solid ${IOS.purple}25`}}>
                  <Typography sx={{fontSize:'0.65rem',fontWeight:700,color:IOS.purple}}>{errorDetalle.MODULO}</Typography>
                </Box>
                <Box sx={{display:'inline-flex',px:1,py:0.3,borderRadius:'20px',bgcolor:IOS.bg,border:`1px solid ${IOS.separator}`}}>
                  <Typography sx={{fontSize:'0.65rem',fontWeight:700,color:IOS.label2}}>{fmtFecha(errorDetalle.FECHA)} {fmtHora(errorDetalle.FECHA)}</Typography>
                </Box>
              </Box>
              <Typography sx={{fontSize:'0.72rem',fontWeight:700,color:IOS.label2,letterSpacing:'0.07em',textTransform:'uppercase',mb:0.5}}>Evento</Typography>
              <Typography sx={{fontSize:'0.85rem',color:IOS.label,fontWeight:600,mb:2}}>{errorDetalle.EVENTO}</Typography>
              <Typography sx={{fontSize:'0.72rem',fontWeight:700,color:IOS.label2,letterSpacing:'0.07em',textTransform:'uppercase',mb:0.5}}>Mensaje completo</Typography>
              <Box sx={{p:1.5,bgcolor:'#FFF0EF',borderRadius:'12px',border:'1px solid #FFD4D1'}}>
                <Typography sx={{fontSize:'0.8rem',color:'#C0392B',lineHeight:1.6,wordBreak:'break-word'}}>{errorDetalle.DETALLE}</Typography>
              </Box>
            </Box>
          </Box>
        </Box>
      )}

      {/* Modal corregir nombre de cliente */}
      {canSend && modalNombre && (
        <Box sx={{position:'fixed',inset:0,zIndex:9999,bgcolor:'rgba(0,0,0,0.45)',display:'flex',alignItems:'center',justifyContent:'center',p:2,backdropFilter:'blur(4px)'}}
          onClick={()=>!corrigiendoNombre&&setModalNombre(null)}>
          <Box onClick={e=>e.stopPropagation()}
            sx={{bgcolor:IOS.surface,borderRadius:'20px',overflow:'hidden',width:420,maxWidth:'92vw',boxShadow:'0 24px 60px rgba(0,0,0,0.25)'}}>
            <Box sx={{px:2.5,pt:2.5,pb:2,borderBottom:`1px solid ${IOS.separator}`}}>
              <Typography sx={{fontSize:'0.72rem',fontWeight:700,color:IOS.label2,letterSpacing:'0.07em',textTransform:'uppercase',mb:0.3}}>Corregir Cliente</Typography>
              <Typography sx={{fontSize:'0.95rem',fontWeight:800,color:IOS.label}}>DNI {modalNombre.DNI}</Typography>
              <Typography sx={{fontSize:'0.75rem',color:IOS.label2,mt:0.3}}>
                Nombre actual: <span style={{fontFamily:'monospace',color:IOS.red}}>{modalNombre.Cliente||'(vacío)'}</span>
              </Typography>
            </Box>
            <Box sx={{p:2.5}}>
              {resultadoNombre && (
                <Box sx={{p:1.5,borderRadius:'10px',mb:2,
                  bgcolor:resultadoNombre.ok?'#EDFAF2':'#FFF0EF',border:`1px solid ${resultadoNombre.ok?'#B7EFD0':'#FFD4D1'}`}}>
                  <Typography sx={{fontSize:'0.78rem',color:resultadoNombre.ok?'#1A6B3C':'#C0392B',fontWeight:600}}>{resultadoNombre.msg}</Typography>
                </Box>
              )}
              <Box sx={{display:'flex',flexDirection:'column',gap:1}}>
                <Box component="button" onClick={corregirDesdeHistorial} disabled={corrigiendoNombre}
                  sx={{height:42,borderRadius:'12px',border:`1px solid ${IOS.blue}30`,bgcolor:`${IOS.blue}0A`,cursor:corrigiendoNombre?'default':'pointer',
                    display:'flex',alignItems:'center',justifyContent:'center',gap:0.8}}>
                  {corrigiendoNombre && <CircularProgress size={14} sx={{color:IOS.blue}}/>}
                  <Typography sx={{fontSize:'0.82rem',fontWeight:700,color:IOS.blue}}>Buscar en historial de compras</Typography>
                </Box>
                <Box component="button" onClick={corregirConReniec} disabled={corrigiendoNombre}
                  sx={{height:42,borderRadius:'12px',border:'none',bgcolor:corrigiendoNombre?'#E5E5EA':IOS.purple,cursor:corrigiendoNombre?'default':'pointer',
                    display:'flex',alignItems:'center',justifyContent:'center',gap:0.8}}>
                  {corrigiendoNombre && <CircularProgress size={14} sx={{color:'white'}}/>}
                  <Typography sx={{fontSize:'0.82rem',fontWeight:700,color:corrigiendoNombre?'#8E8E93':'white'}}>Buscar en RENIEC</Typography>
                </Box>
              </Box>

              {historialFallo && reniecFallo && (
                <>
                  <Box sx={{display:'flex',alignItems:'center',gap:1,my:1.8}}>
                    <Box sx={{flex:1,height:'1px',bgcolor:IOS.separator}}/>
                    <Typography sx={{fontSize:'0.65rem',color:IOS.label2,fontWeight:600}}>ÚLTIMO RECURSO</Typography>
                    <Box sx={{flex:1,height:'1px',bgcolor:IOS.separator}}/>
                  </Box>

                  <Typography sx={{fontSize:'0.68rem',color:IOS.label2,mb:0.6}}>
                    Corregir manualmente — el DNI <strong>{modalNombre.DNI}</strong> se mantiene intacto
                  </Typography>
                  <Box sx={{display:'flex',gap:0.8}}>
                    <input value={nombreManual} onChange={e=>setNombreManual(e.target.value.toUpperCase())} disabled={corrigiendoNombre}
                      style={{flex:1,height:38,padding:'0 10px',border:`1px solid ${IOS.separator}`,borderRadius:10,fontSize:'0.8rem',color:IOS.label,backgroundColor:IOS.surface,outline:'none',fontFamily:'inherit',boxSizing:'border-box'}}
                      onFocus={e=>e.target.style.borderColor=IOS.blue}
                      onBlur={e=>e.target.style.borderColor=IOS.separator}/>
                    <Box component="button" onClick={corregirManual} disabled={corrigiendoNombre||!nombreManual.trim()}
                      sx={{height:38,px:1.8,borderRadius:'10px',border:'none',flexShrink:0,
                        bgcolor:(corrigiendoNombre||!nombreManual.trim())?'#E5E5EA':IOS.label,
                        cursor:(corrigiendoNombre||!nombreManual.trim())?'default':'pointer',
                        display:'flex',alignItems:'center',justifyContent:'center'}}>
                      <Typography sx={{fontSize:'0.76rem',fontWeight:700,color:(corrigiendoNombre||!nombreManual.trim())?'#8E8E93':'white'}}>Guardar</Typography>
                    </Box>
                  </Box>
                </>
              )}
            </Box>
            <Box sx={{px:2.5,py:1.8,borderTop:`1px solid ${IOS.separator}`,display:'flex',justifyContent:'flex-end'}}>
              <Box component="button" onClick={()=>setModalNombre(null)} disabled={corrigiendoNombre}
                sx={{height:34,px:2,borderRadius:'10px',border:`1px solid ${IOS.separator}`,bgcolor:IOS.bg,cursor:'pointer',fontSize:'0.78rem',fontWeight:600,color:IOS.label}}>
                Cerrar
              </Box>
            </Box>
          </Box>
        </Box>
      )}

      {/* Modal corregir fecha fuera de plazo */}
      {canSend && modalFecha && (
        <Box sx={{position:'fixed',inset:0,zIndex:9999,bgcolor:'rgba(0,0,0,0.45)',display:'flex',alignItems:'center',justifyContent:'center',backdropFilter:'blur(6px)'}}
          onClick={()=>!corrigiendo&&setModalFecha(null)}>
          <Box onClick={e=>e.stopPropagation()}
            sx={{bgcolor:IOS.surface,borderRadius:'20px',p:3,width:420,boxShadow:'0 24px 60px rgba(0,0,0,0.2)'}}>
            <Box sx={{display:'flex',alignItems:'center',gap:1.5,mb:2}}>
              <Box sx={{width:44,height:44,borderRadius:'12px',bgcolor:'#FFF8E6',border:'1px solid #FFE9A0',display:'flex',alignItems:'center',justifyContent:'center'}}>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={IOS.orange} strokeWidth="2" strokeLinecap="round"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
              </Box>
              <Box>
                <Typography sx={{fontSize:'0.95rem',fontWeight:800,color:IOS.label}}>Corregir fecha fuera de plazo</Typography>
                <Typography sx={{fontSize:'0.72rem',color:IOS.label2}}>{modalFecha.Comprobante} — {modalFecha.Cliente}</Typography>
              </Box>
            </Box>
            <Box sx={{p:1.5,bgcolor:'#FFF8E6',borderRadius:'10px',border:'1px solid #FFE9A0',mb:2}}>
              <Typography sx={{fontSize:'0.75rem',color:'#8B6914',lineHeight:1.5}}>
                Revisa la fecha original ({modalFecha.Fecha}). El servidor validará el plazo según el tipo de comprobante.
                Al corregir la fecha, se eliminará el registro de envío fallido y podrás reenviarlo desde "Envío Masivo SUNAT".
              </Typography>
            </Box>
            <Box sx={{mb:2.5}}>
              <Lbl>Nueva fecha de venta</Lbl>
              <DatePickerIOS value={nuevaFecha} onChange={setNuevaFecha} minDate={minFechaCorreccion} maxDate={hoyYMD} />
            </Box>
            <Box sx={{display:'flex',gap:1}}>
              <Box component="button" onClick={()=>setModalFecha(null)} disabled={corrigiendo}
                sx={{flex:1,height:40,borderRadius:'12px',border:`1px solid ${IOS.separator}`,bgcolor:IOS.bg,cursor:'pointer',fontSize:'0.82rem',fontWeight:600,color:IOS.label}}>
                Cancelar
              </Box>
              <Box component="button" onClick={corregirFecha} disabled={corrigiendo||!nuevaFecha}
                sx={{flex:1,height:40,borderRadius:'12px',border:'none',bgcolor:!nuevaFecha?'#E5E5EA':IOS.orange,
                  cursor:corrigiendo||!nuevaFecha?'default':'pointer',display:'flex',alignItems:'center',justifyContent:'center',gap:0.8,
                  transition:'all 0.2s','&:hover':{filter:'brightness(0.92)'}}}>
                {corrigiendo&&<CircularProgress size={14} sx={{color:'white'}}/>}
                <Typography sx={{fontSize:'0.82rem',fontWeight:700,color:!nuevaFecha?'#8E8E93':'white'}}>
                  {corrigiendo?'Corrigiendo...':'Confirmar corrección'}
                </Typography>
              </Box>
            </Box>
          </Box>
        </Box>
      )}
    </>
  );
};

export default MonitorEnvios;
